$(document).on('click', '.tooltip', function(event){
	$(this).remove()
});